module.exports = __webpack_public_path__ + "img/fat-lifting_hwmf10_c_scale,w_952.0c444266.jpg";